<div class="com-pro">
    <div class="tile">
        <div class="tile-title">
            <h5 class="l-space-between-containers"><strong>Driving Behaviour</strong></h5>
        </div>
        <div class="tile-chart-area" *ngIf="drivingBehaviour?.length">
            <app-plotly-bar [barData]="drivingBehaviour"></app-plotly-bar>
        </div>
    </div>
    <div class="tile">
        <div class="tile-title">
            <h5 class="l-space-between-containers"><strong>Vehicle Utilization</strong></h5>
        </div>
        <div class="tile-chart-area" *ngIf="entityUtilization?.length">
            <app-plotly-donut [donutData]="entityUtilization"></app-plotly-donut>
        </div>
    </div>
    <div class="tile">
        <div class="tile-title">
            <h5 class="l-space-between-containers"><strong>Vehicle Health</strong></h5>
        </div>
        <div class="grid-3">
            <div class="tab-health-table-wrapper col-spacing">
                <div class="set-col">
                    <span><strong>Issue Type</strong></span><br>
                    <span><img src="../../assets/images/engine.svg" class="w-20" alt="engine"
                            title="Engine">&nbsp;Engine</span>
                    <br>
                    <span><img src="../../assets/images/coolant.svg" class="w-20" alt="coolant"
                            title="Coolant">&nbsp;Coolant</span>
                    <br>
                    <span><img src="../../assets/images/batterynew.svg" class="w-20" alt="battery"
                            title="Battery">&nbsp;Battery</span>
                </div>
                <div class="set-col">
                    <span><strong>Status</strong></span><br>
                    <span class="cg">Good</span>
                    <br><span class="cr">Inspection required</span><br>
                    <span class="cr">Issue found</span>
                </div>
                <div class="set-col">
                    <span><strong>Error Code</strong></span><br>
                    <span class="cr">{{entityData?.entityHealthDetails?.issueType[0].engine?.errorCode
                        ? entityData?.entityHealthDetails?.issueType[0].engine?.errorCode :
                        'NA'}}</span>
                    <br><span class="cg">{{entityData?.entityHealthDetails.issueType[1].coolent?.errorCode
                        ? entityData.entityHealthDetails.issueType[1].coolent?.errorCode:
                        'NA'}}</span><br>
                    <span class="cg">{{entityData?.entityHealthDetails.issueType[2].battery?.errorCode
                        ? entityData.entityHealthDetails.issueType[2].battery?.errorCode:
                        'NA'}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="tile">
        <div class="tile-title">
            <h5 class="l-space-between-containers"><strong>Active Alerts - 22</strong></h5>
        </div>
        <div class="tile-chart-area" *ngIf="activeAlerts?.length">
            <app-plotly-bar [barData]="activeAlerts"></app-plotly-bar>
        </div>
    </div>
</div>